module.exports = __webpack_public_path__ + "img/logo4.856d1212.jpg";